const healthPlansStrings = {
  healthPlan: {
    emptyState: 'There are no health plans',
    createHealthPlan: 'Create health plan',
    healthPlan: 'Health plan name',
    healthPlanPlaceholder: 'Health plan name',
    insurance: 'Insurance',
    insurancePlaceholder: 'Select insurance',
    createPlan: 'Create Health Plan',
    editPlan: 'Edit Health Plan',
    cancel: 'Cancel',
    showMore: 'Show More',
  },
  healthPlanList: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      healthPlans: 'Health Plans',
      insurance: 'Insurance',
      status: 'Status',
    },
  },
  categories: {
    categories: 'Categories',
    labs: 'Labs',
    scans: 'Scans',
    pharmacies: 'Pharmacies',
    clinicServices: 'InClinic Services',
    doctorConsultations: 'Doctor consultations',
    surgical: 'Surgical',
    providerDiscounts: 'Medical Network Discounts',
  },
};

export default healthPlansStrings;
